import * as React from "react";
import useUserDateTime from "hooks/useUserDateTime";
import { adjustFormat } from "util/DateTime";
const DefaultRender = ({ value, field: _field }) => /* @__PURE__ */ React.createElement(React.Fragment, null, value);
const Timestamp = ({
  dateTime = void 0,
  field = void 0,
  format = "default",
  render: Component = DefaultRender,
  tz = void 0,
  className = void 0
}) => {
  const { formatTime: formatWithUserTz } = useUserDateTime();
  if (!dateTime) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null);
  }
  const formattedDateTime = tz ? adjustFormat(dateTime, format, tz) : formatWithUserTz(dateTime, format);
  const dateTimeString = adjustFormat(dateTime, "internal");
  return /* @__PURE__ */ React.createElement("time", { dateTime: dateTimeString, title: dateTimeString, className }, /* @__PURE__ */ React.createElement(Component, { value: formattedDateTime, field }));
};
export default Timestamp;
